import { Button } from "@/components/ui/button/button";

import { PurchaseSwitchSection } from "./purchase-switch-section";

import type { ComponentProps } from "react";

type PurchaseDialogContentProps = {
	ticketListComponent: () => JSX.Element;
	isStopRecurringProBilling: boolean;
	onUpdateIsStopRecurringProBilling: () => void;
	isValid: boolean;
	onPurchase: () => Promise<void>;
};

export const PurchaseDialogContent = ({
	ticketListComponent,
	isStopRecurringProBilling,
	onUpdateIsStopRecurringProBilling,
	isValid,
	onPurchase,
}: PurchaseDialogContentProps) => {
	const variant: ComponentProps<typeof Button>["variant"] = isValid ? "default" : "disabled";

	return (
		<div className="space-y-8">
			<div className="space-y-1 text-sm">
				<p>適用期間は予約ごとの手数料が0%になり、予約手数料の増額を避けることができます。</p>
				<p>定額チケットを追加購入すると、現在適用中のチケットの有効期限が延長されます。</p>
				<p>予約手数料は「宿泊日」ではなく「予約日」に計算されるため、</p>
				<p>繁忙期の予約が入り始める時期に、定額課金に切り替えることをお勧めします。</p>
			</div>

			{ticketListComponent()}

			<PurchaseSwitchSection
				isStopRecurringProBilling={isStopRecurringProBilling}
				onUpdateIsStopRecurringProBilling={onUpdateIsStopRecurringProBilling}
			/>

			<div className="flex justify-end">
				<Button variant={variant} size="xl" onClick={onPurchase}>
					購入
				</Button>
			</div>
		</div>
	);
};

PurchaseDialogContent.displayName = "PurchaseDialogContent";
